module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/pill-style2/pill-style2.component.scss
// module id = ./src/app/features/tabination/pill-style2/pill-style2.component.scss
// module chunks = main